var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:_vm.btnPaddingClass,attrs:{"value":_vm.value,"to":_vm.route}},[_c('span',[_vm._v(_vm._s(_vm.label))]),_c('v-icon',{attrs:{"color":_vm.iconColor}},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }